let TeacherConstant = {
    major: {
        CLASSIC: 0, JAZZ: 1, MANAGER: 2
    },
    ID_SELECT_ALL: 0,
    major_text: ["클래식", "재즈", "매니저"],
    major_symbol: ["C", "J", "M"],
}

export default TeacherConstant;